<template>
  <div></div>
</template>

<script>
  // 堆叠条形图
  export default {
    data() {
      return {}
    },
    computed: {},
    methods: {},
    components: {},
    watch: {}
  }
</script>

<style rel="stylesheet" lang="less">

</style>
